var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.itemArr),function(item,itemIndex){return _c('div',{key:itemIndex,staticClass:"reading_content",style:({ fontSize: _vm.fontSize + 'rpx' })},[_c('div',{domProps:{"innerHTML":_vm._s(item)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }